export default class Routes {
    public static readonly Home = class {
        public static readonly Root = 'HomeRoot';
    };

    public static readonly Driver = class {
        public static readonly Root = 'DriverRoot';
    };

    public static readonly Transports = class {
        public static readonly Root = 'TransportsRoot';
        public static readonly Export = 'TransportsExport';
        public static readonly Import = 'TransportsImport';
        public static readonly Other = 'TransportsOther';
        public static readonly History = 'TransportsHistory';
    };

    public static readonly Login = class {
        public static readonly Root = 'LoginRoot';
        public static readonly ForgotPassword = 'LoginForgotPassword';
        public static readonly Mfa = 'LoginMfa';
        public static readonly MfaRecovery = 'LoginMfaRecovery';
        public static readonly PasswordReset = 'LoginPasswordReset';
        public static readonly ConfirmEmail = 'LoginConfirmEmail';
    };

    public static readonly Account = class {
        public static readonly Root = 'AccountRoot';
        public static readonly Profile = 'AccountProfile';
        public static readonly Email = 'AccountEmail';
        public static readonly Password = 'AccountPassword';
        public static readonly Mfa = 'AccountMfa';
        public static readonly MfaEnable = 'AccountMfaEnable';
        public static readonly MfaRemove = 'AccountMfaRemove';
        public static readonly MfaReset = 'AccountMfaReset';
        public static readonly MfaRecoveryCodes = 'AccountMfaRecoveryCodes';

    };

    public static readonly Maintenance = class {
        public static readonly Root = 'MaintenanceRoot';
        public static readonly Users = 'MaintenanceUsers';
        public static readonly Roles = 'MaintenanceRoles';
        public static readonly Stations = 'MaintenanceStations';
        public static readonly Carriers = 'MaintenanceCarriers';
        public static readonly Sla = 'MaintenanceSla';
        public static readonly Locations = 'MaintenanceLocations';
        public static readonly Categories = 'MaintenanceCategories';
        public static readonly Customers = 'MaintenanceCustomers';
    };

    public static readonly ApiDocs = 'ApiDocs';

    public static readonly AccessDenied = 'AccessDenied';
}

/** Every route name in `Routes`, i.e. every named page of the app. */
export function routeNames(node: object = Routes): string[] {
    return Object.values(node).flatMap(value => typeof value === 'string' ? [ value ] : routeNames(value as object));
}

export type RoutesType = 'HomeRoot' |
    'DriverRoot' |
    'TransportsRoot' |
    'TransportsExport' |
    'TransportsImport' |
    'TransportsOther' |
    'TransportsHistory' |
    'LoginRoot' |
    'LoginForgotPassword' |
    'LoginMfa' |
    'LoginMfaRecovery' |
    'LoginPasswordReset' |
    'LoginConfirmEmail' |
    'AccountRoot' |
    'AccountProfile' |
    'AccountEmail' |
    'AccountPassword' |
    'AccountMfa' |
    'AccountMfaEnable' |
    'AccountMfaRemove' |
    'AccountMfaReset' |
    'AccountMfaRecoveryCodes' |
    'MaintenanceRoot' |
    'MaintenanceUsers' |
    'MaintenanceRoles' |
    'MaintenanceStations' |
    'MaintenanceCarriers' |
    'MaintenanceSla' |
    'MaintenanceLocations' |
    'MaintenanceCategories' |
    'MaintenanceCustomers' |
    'ApiDocs' |
    'AccessDenied';